import { render } from "./TableController2.vue?vue&type=template&id=1b7aed90&scoped=true"
import script from "./TableController2.vue?vue&type=script&lang=js"
export * from "./TableController2.vue?vue&type=script&lang=js"

import "./TableController2.vue?vue&type=style&index=0&id=1b7aed90&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7aed90"]])

export default __exports__